export default __webpack_public_path__ + "static/media/visa.b7abb312.svg";